import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { Box, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { useLangFile } from 'js/context/LanguageContext';
import CircularProgress from '@mui/material/CircularProgress';

const PrescriptionUpdateJobDialog = ({
  open,
  savingJob,
  savingError,
  onCancel,
  onOverwrite,
  onSaveAsNew,
  info,
}) => {
  const LangFile = useLangFile();

  return (
    <Fragment>
      <Dialog open={Boolean(open)} fullWidth maxWidth={'md'}>
        <DialogTitle>
          {savingJob && LangFile.PrescriptionSaveDialog.saving}
          {!savingJob && LangFile.PrescriptionUpdateJobDialog.title}
        </DialogTitle>

        <DialogContent style={{ overflow: 'hidden' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {savingJob ? (
              <CircularProgress size={80} thickness={5} />
            ) : (
              <Fragment>
                <Box
                  sx={{
                    mb: 1,
                  }}
                >
                  {info}
                </Box>
              </Fragment>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          {!savingJob && (
            <Fragment>
              <Button onClick={onCancel} color={'inherit'} variant={'outlined'}>
                {LangFile.PrescriptionUpdateJobDialog.cancel}
              </Button>
              {onOverwrite && (
                <Button onClick={onOverwrite} color={'inherit'} variant={'outlined'}>
                  {LangFile.PrescriptionUpdateJobDialog.overwriteJob}
                </Button>
              )}
              <Button onClick={onSaveAsNew} color={'primary'} variant={'contained'}>
                {LangFile.PrescriptionUpdateJobDialog.saveAsNewJob}
              </Button>
            </Fragment>
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default memo(PrescriptionUpdateJobDialog);

PrescriptionUpdateJobDialog.propTypes = {
  open: PropTypes.bool,
  savingJob: PropTypes.bool,
  savingError: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onOverwrite: PropTypes.func,
  onSaveAsNew: PropTypes.func.isRequired,
  info: PropTypes.string,
};
